<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import { required } from "vuelidate/lib/validators";
import Multiselect from 'vue-multiselect';
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/es';
import moment from 'moment';

import { categories } from "./data-calendar";

/**
 * Calendar component
 */
export default {
    components: { FullCalendar, Multiselect, DatePicker, moment },
    data() {
        return {
            title: "Calendar",
            items: [
                {
                text: "Calendar",
                active: true
                }
            ],
            eventTimeFormat: { // like '14:30:00'
                hour: '2-digit',
                minute: '2-digit'
            },
            calendarWeekends: true,
            calendarPlugins: [
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin,
                bootstrapPlugin,
                listPlugin
            ],
            themeSystem: "bootstrap",
            calendarEvents: [],
            showModal: false,
            eventModal: false,
            categories: categories,
            submitted: false,
            submit: false,
            newEventData: {},
            edit: {},
            deleteId: {},
            event: {
                user_id:'',
                title: '',
                category: '',
                servicio:'',
                profesional:'',
                hora:'',
                fecha:''
            },
            editevent: {
                user_id:'',
                title: '',
                category: '',
                servicio:'',
                profesional:'',
                hora:'',
                fecha:''
            },
            validations: {
                event: {
                    user_id: {required},
                    servicio: {required},
                    profesional: {required},
                    hora: {required}
                },
            },
            usersOptions:[],
            serviciosOptions:[],
            profesionalOptions:[],
            tipos:[],
            subtipos:[],
            copiado:false,
            coordinador:'',
            allCoordinadores: [],
            coordinadores:[],
            tipoFiltro: '',
            calendarEventsFiltrados:[],
            modoColor: 'estado', // 'estado' | 'tipo'
            coloresTipo: {
                'Actividad Carrera':   { bg: '#1a2a6c', border: '#111d4e' },
                'Actividad Docentes':  { bg: '#1e3a8a', border: '#162d6e' },
                'Charla':              { bg: '#1d4ed8', border: '#1740b0' },
                'Ensayo PAES':         { bg: '#2563eb', border: '#1d56d0' },
                'Stand':               { bg: '#3b82f6', border: '#2871e0' },
                'Feria':               { bg: '#60a5fa', border: '#4a90e8' },
                'Visita Campus':       { bg: '#7dd3fc', border: '#5bbce8' },
                'Webinar':             { bg: '#38bdf8', border: '#22a8e0' },
                'Vinculación Escolar': { bg: '#0ea5e9', border: '#0891d0' },
            },
            isSmallScreen: window.innerWidth < 768,
            tooltip: { visible: false, ev: {}, x: 0, y: 0 }
        };
    },
    computed: {
        initialView() {
            return 'dayGridMonth';
        }
    },
    validations: {
        event: {
            title: { required },
            category: { required }
        }
    },
    watch: {
       // Cambiar vista del calendario cuando cambie el tamaño de pantalla
        isSmallScreen(newVal, oldVal) {
            if (newVal === oldVal) return;
            const view = newVal ? 'timeGridDay' : 'dayGridMonth';
            this.setCalendarView(view);
        }
    },
    methods: {
        setCalendarView(view) {
            // intenta obtener la API de fullcalendar y cambiar la vista
            try {
                const api = this.$refs.fullCalendar && this.$refs.fullCalendar.getApi && this.$refs.fullCalendar.getApi();
                if (api && typeof api.changeView === 'function') {
                    api.changeView(view);
                }
            } catch (e) {
                // silencioso: puede ejecutarse antes de que el calendario esté inicializado
                console.warn('setCalendarView:', e);
            }
        },
        async copiarLink(link) {
            try {
                await navigator.clipboard.writeText(link);
                this.copiado = true;
                this.$toasted.success('Link Copiado');
                setTimeout(() => (this.copiado = false), 2000);
            } catch (err) {
                this.$toasted.error("Error al copiar: ", err);
            }
        },
        /**
         * Modal form submit
         */
        labelselect ({ name }) {
            return `${name}`
        },
        /**
         * Modal open for edit event
         */
        editEvent(info) { //mostrara info del evento
            if (info && info.jsEvent && (info.jsEvent.ctrlKey || info.jsEvent.metaKey)) {
                this.ver_evento(info.event.extendedProps || info.event, true);
                return;
            }

            console.log(info);
            this.edit = info.event;
            this.editevent = this.edit.extendedProps;
            this.eventModal = true;
        },
        closeModal() {
            this.eventModal = false;
        },
        esCerrado(ev) {
            const estado = (ev.estado_actividad || '').toLowerCase();
            if (estado.includes('cerrad')) return true;
            // También cerrado si la fecha de término ya pasó
            const fin = ev.fecha_termino || ev.end;
            if (fin && new Date(fin) < new Date()) return true;
            return false;
        },
        colorEvento(ev) {
            const estado = (ev.estado_actividad || '').toLowerCase();
            if (this.modoColor === 'tipo') {
                // En modo tipo, Cancelado sigue siendo rojo
                if (estado.includes('cancel')) return { bg: '#e74c3c', border: '#c0392b' };
                const tipo = ev.tipo_codigo || ev.tipo || '';
                return this.coloresTipo[tipo] || { bg: '#252C5F', border: '#1a1f44' };
            }
            // modo estado
            if (estado.includes('cancel')) return { bg: '#e74c3c', border: '#c0392b' };
            if (this.esCerrado(ev)) return { bg: '#6b7280', border: '#4b5563' };
            return { bg: '#252C5F', border: '#1a1f44' };
        },
        toggleModoColor() {
            this.modoColor = this.modoColor === 'estado' ? 'tipo' : 'estado';
            // Re-colorear eventos sin recargar datos
            this.calendarEvents = this.calendarEvents.map(ev => {
                const c = this.colorEvento(ev.extendedProps);
                return { ...ev, backgroundColor: c.bg, borderColor: c.border };
            });
            this.filtrarEventos();
        },
        esInteraccionSimulador(ev) {
            const nombre = String(
                (ev && (ev.nombre_difusion || ev.title || ev.nombre || '')) || ''
            )
                .trim()
                .toLowerCase();

            return nombre.startsWith('interaccion simulador') || nombre.startsWith('interacción simulador');
        },
        get_data(){
            this.isLoading = true;
            axios.get('/api/get_proximos_eventos').then(res => {
                const mapear = (evs) => evs.map(ev => {
                    const c = this.colorEvento(ev);
                    return {
                        id: ev.id,
                        title: ev.nombre_difusion || ev.title || '',
                        start: ev.start || ev.fecha_inicio,
                        end: ev.end || ev.fecha_termino,
                        backgroundColor: c.bg,
                        borderColor: c.border,
                        textColor: '#fff',
                        extendedProps: { ...ev }
                    };
                });
                const eventosSinSimulador = (res.data.eventos || []).filter(ev => !this.esInteraccionSimulador(ev));
                this.calendarEvents = mapear(eventosSinSimulador);
                this.calendarEventsFiltrados = [...this.calendarEvents];
            }).catch(e => {
                this.isLoading = false;
            });
        },
        ver_evento(evento, nuevaPestana = false){
            const eventoObj = (evento && typeof evento === 'object') ? evento : null;
            const codigo = (eventoObj && eventoObj.codigo) ? eventoObj.codigo : evento;
            const eventoId = eventoObj && eventoObj.id ? eventoObj.id : null;

            if (codigo) {
                localStorage.setItem('evento_codigo', codigo);
            }
            if (eventoId) {
                localStorage.setItem('evento_id', String(eventoId));
            }

            const params = new URLSearchParams();
            if (eventoId) {
                params.set('evento_id', String(eventoId));
            }
            if (codigo) {
                params.set('evento_codigo', String(codigo));
            }

            const destino = `/web/configuracion/eventos${params.toString() ? `?${params.toString()}` : ''}`;

            if (nuevaPestana) {
                window.open(destino, '_blank', 'noopener');
                return;
            }

            window.location.href = destino;
        },
        filtrarEventos() {
            let eventosFiltrados = this.calendarEvents.filter(evento =>
                !this.esInteraccionSimulador(evento.extendedProps || evento)
            );
            if (this.tipoFiltro) {
                eventosFiltrados = eventosFiltrados.filter(evento =>
                    (evento.extendedProps && evento.extendedProps.tipo_codigo === this.tipoFiltro.codigo) ||
                    (evento.extendedProps && evento.extendedProps.tipo === this.tipoFiltro.codigo)
                );
            }
            this.calendarEventsFiltrados = eventosFiltrados;
        },
        actualizarCoordinadores() {
            this.coordinadores = [...new Set(this.allCoordinadores.map(c => c.nombre))];
            if (!this.coordinadores.includes(this.coordinador)) {
                this.coordinador = '';
            }
        },
        handleResize() {
            this.isSmallScreen = window.innerWidth < 768;
        },
        _removeTooltip() {
            const existing = document.getElementById('ugm-cal-tooltip');
            if (existing) existing.remove();
        },
        onEventMouseEnter(info) {
            this._removeTooltip();
            const ev = info.event.extendedProps;
            // Usar info.event.start (objeto Date que FullCalendar ya parseó) como fuente más confiable
            const fechaObj = info.event.start;
            const fechaStr = fechaObj
                ? fechaObj.toLocaleDateString('es-CL', { day: '2-digit', month: 'long', year: 'numeric' })
                : (ev.fecha_inicio ? ev.fecha_inicio.split(' ')[0] : '—');
            const rect = info.el.getBoundingClientRect();
            let x = rect.left;
            let y = rect.bottom + 8;
            if (x + 280 > window.innerWidth) x = window.innerWidth - 288;
            if (y + 230 > window.innerHeight) y = rect.top - 236;

            const div = document.createElement('div');
            div.id = 'ugm-cal-tooltip';
            div.style.cssText = `position:fixed;left:${x}px;top:${y}px;z-index:99999;pointer-events:none;width:270px;font-family:inherit;`;
            div.innerHTML = `
                <div style="background:#fff;border-radius:10px;box-shadow:0 8px 32px rgba(37,44,95,.22);overflow:hidden;animation:ugmTooltipIn .15s ease;">
                    <div style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);padding:10px 14px;">
                        <p style="margin:0;font-size:10px;color:rgba(255,255,255,.8);text-transform:uppercase;letter-spacing:.05em;">Evento</p>
                        <p style="margin:0;font-weight:700;color:#fff;font-size:13px;line-height:1.3;">${ev.nombre_difusion || ''}</p>
                    </div>
                    <div style="padding:10px 14px;">
                        ${ev.codigo ? `<div style="display:flex;align-items:center;margin-bottom:5px;"><span style="color:#61B7E4;margin-right:6px;">&#128196;</span><span style="font-size:11px;color:#6c757d;font-family:monospace;letter-spacing:.03em;">${ev.codigo}</span></div>` : ''}
                        <div style="display:flex;align-items:center;margin-bottom:5px;">
                            <span style="color:#61B7E4;margin-right:6px;">&#127968;</span>
                            <span style="font-size:12px;color:#252C5F;">${(() => { try { const l = ev.colegios_json ? JSON.parse(ev.colegios_json) : null; return l && l.length > 1 ? l.map(c => c.nombre).join(', ') : (ev.colegio || '—'); } catch(e){ return ev.colegio || '—'; } })()}</span>
                        </div>
                        <div style="display:flex;align-items:center;">
                            <span style="color:#61B7E4;margin-right:6px;">&#128197;</span>
                            <span style="font-size:12px;color:#252C5F;">${fechaStr}</span>
                        </div>
                    </div>
                    <div style="padding:4px 14px 8px;border-top:1px solid #f0f2fa;">
                        <span style="font-size:11px;color:#6c757d;">&#128432; Clic para ver detalles</span>
                    </div>
                </div>`;
            document.body.appendChild(div);
        },
        onEventMouseLeave() {
            this._removeTooltip();
        }
    },
    mounted() {
        axios.get('/api/get_tipos').then(res=>{
            this.tipos = res.data.tipos;
            this.subtipos = res.data.subtipos;
        });
        this.get_data();
       // asegurar vista inicial correcta al montar
       this.$nextTick(() => this.setCalendarView(this.initialView));
    },
    created(){
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
        this._removeTooltip();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        this._removeTooltip();
    },
};
</script>

<template>
    <div>
        <div class="row mb-3" v-if="user.rol!='Laborante'">
            <div class="col-md-12">
                <div class="card shadow-sm mb-0" style="border-left: 4px solid #252C5F;">
                    <div class="card-body py-3">
                        <!-- Filtro tipo + botón toggle -->
                        <div class="d-flex align-items-center flex-wrap" style="gap:12px;">
                            <label class="mb-0 font-weight-semibold font-size-13 text-nowrap" style="color:#252C5F; min-width:90px;">
                                <i class="mdi mdi-tag-outline mr-1"></i>Tipo de evento
                            </label>
                            <div style="min-width:220px; flex:1; max-width:360px;">
                                <multiselect
                                    v-model="tipoFiltro"
                                    :options="tipos"
                                    label="nombre"
                                    track-by="codigo"
                                    placeholder="Seleccionar tipo..."
                                    selectLabel="Presiona para seleccionar"
                                    selectedLabel="Seleccionado"
                                    deselectLabel="Presiona para remover"
                                >
                                    <template v-slot:noOptions><p class="mb-0">Sin opciones</p></template>
                                    <template v-slot:noResult><p class="mb-0">Sin coincidencias</p></template>
                                </multiselect>
                            </div>
                            <button class="btn btn-ugm-dark" style="white-space:nowrap;" @click="filtrarEventos">
                                <i class="mdi mdi-filter mr-1"></i>Filtrar
                            </button>
                            <button class="btn btn-ugm-white" style="white-space:nowrap;" v-if="tipoFiltro" @click="tipoFiltro=null; filtrarEventos()">
                                <i class="mdi mdi-close mr-1"></i>Limpiar
                            </button>
                        </div>
                        <!-- Botón toggle modo color -->
                        <div class="mt-3 pt-2" style="border-top:1px solid #f0f2fa;">
                            <div class="d-flex align-items-center" style="gap:10px;">
                                <span class="font-weight-semibold font-size-13" style="color:#252C5F;">
                                    <i class="mdi mdi-palette-outline mr-1"></i>Color por:
                                </span>
                                <button
                                    class="btn btn-sm"
                                    :style="modoColor==='estado' ? 'background:#252C5F;color:#fff;border-color:#252C5F;' : 'background:#fff;color:#252C5F;border:1px solid #252C5F;'"
                                    @click="toggleModoColor"
                                    style="min-width:80px;"
                                >
                                    Estado
                                </button>
                                <button
                                    class="btn btn-sm"
                                    :style="modoColor==='tipo' ? 'background:#252C5F;color:#fff;border-color:#252C5F;' : 'background:#fff;color:#252C5F;border:1px solid #252C5F;'"
                                    @click="toggleModoColor"
                                    style="min-width:80px;"
                                >
                                    Tipo
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Leyenda dinámica -->
        <div class="row mb-2" v-if="user.rol!='Laborante'">
            <div class="col-md-12">
                <div class="d-flex flex-wrap align-items-center" style="gap:10px;">
                    <!-- Leyenda estado -->
                    <template v-if="modoColor==='estado'">
                        <span class="d-flex align-items-center font-size-12" style="gap:5px;">
                            <span style="display:inline-block;width:12px;height:12px;border-radius:3px;background:#252C5F;"></span> Vigente
                        </span>
                        <span class="d-flex align-items-center font-size-12" style="gap:5px;">
                            <span style="display:inline-block;width:12px;height:12px;border-radius:3px;background:#6b7280;"></span> Cerrado
                        </span>
                        <span class="d-flex align-items-center font-size-12" style="gap:5px;">
                            <span style="display:inline-block;width:12px;height:12px;border-radius:3px;background:#e74c3c;"></span> Cancelado
                        </span>
                    </template>
                    <!-- Leyenda tipo -->
                    <template v-if="modoColor==='tipo'">
                        <span v-for="(col, nombre) in coloresTipo" :key="nombre" class="d-flex align-items-center font-size-12" style="gap:5px;">
                            <span :style="'display:inline-block;width:12px;height:12px;border-radius:3px;background:'+col.bg+';'"></span>
                            {{ nombre }}
                        </span>
                    </template>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <!-- <b-button variant="primary" class="mb-3" >Descargar Eventos</b-button> -->
                        <div class="app-calendar ugm-calendar">
                            <FullCalendar
                                ref="fullCalendar"
                                :initialView="initialView"
                                locale="es"
                                :firstDay="1"
                                :buttonText="{ today:'Hoy', month:'Mes', week:'Semana', day:'Día', list:'Lista' }"
                                :header="{ left: 'prev,next today', center: 'title', right: 'dayGridMonth,listMonth' }"
                                :editable="false"
                                :droppable="false"
                                :plugins="calendarPlugins"
                                :events="calendarEventsFiltrados"
                                :weekends="calendarWeekends"
                                :theme-system="themeSystem"
                                :eventTimeFormat="eventTimeFormat"
                                :noEventsText="'No hay eventos para mostrar'"
                                @eventClick="editEvent"
                                @eventMouseEnter="onEventMouseEnter"
                                @eventMouseLeave="onEventMouseLeave"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Edit Modal -->
        <b-modal
            v-model="eventModal"
            hide-header
            hide-footer
            centered
            body-class="p-0"
            content-class="modal-ugm"
        >
            <!-- Header degradado -->
            <div class="d-flex align-items-center px-4 py-3" style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 6px 6px 0 0;">
                <i class="mdi mdi-calendar-check font-size-22 text-white mr-2"></i>
                <div class="flex-grow-1">
                    <h6 class="mb-0 text-white font-weight-bold">Información del Evento</h6>
                    <small class="text-white" style="opacity:.8;">{{ editevent.codigo }}</small>
                </div>
                <button type="button" class="btn-close-ugm" @click="closeModal">
                    <i class="mdi mdi-close"></i>
                </button>
            </div>

            <!-- Cuerpo -->
            <div class="px-4 py-3">
                <!-- Actividad destacada -->
                <div class="mb-3 p-3 rounded" style="background:#f4f6fb; border-left: 4px solid #CB9700;">
                    <p class="mb-0 font-size-13 text-muted text-uppercase font-weight-bold" style="letter-spacing:.05em;">Actividad</p>
                    <p class="mb-0 font-size-15 font-weight-bold" style="color:#252C5F;">{{ editevent.nombre_difusion }}</p>
                </div>

                <!-- Grid de datos -->
                <div class="row">
                    <div class="col-6">
                        <p class="mb-1 font-size-11 text-uppercase text-muted font-weight-bold">Fecha Inicio</p>
                        <p class="mb-3 font-size-13" style="color:#252C5F;">
                            <i class="mdi mdi-calendar-arrow-right mr-1" style="color:#61B7E4;"></i>{{ editevent.fecha_inicio }}
                        </p>
                    </div>
                    <div class="col-6">
                        <p class="mb-1 font-size-11 text-uppercase text-muted font-weight-bold">Fecha Término</p>
                        <p class="mb-3 font-size-13" style="color:#252C5F;">
                            <i class="mdi mdi-calendar-arrow-left mr-1" style="color:#61B7E4;"></i>{{ editevent.fecha_termino }}
                        </p>
                    </div>
                    <div class="col-6">
                        <p class="mb-1 font-size-11 text-uppercase text-muted font-weight-bold">RBD</p>
                        <p class="mb-3 font-size-13" style="color:#252C5F;">
                            <i class="mdi mdi-identifier mr-1" style="color:#61B7E4;"></i>
                            <template v-if="editevent.colegios_json && JSON.parse(editevent.colegios_json).length > 1">
                                <span v-for="(c,i) in JSON.parse(editevent.colegios_json)" :key="c.rbd">{{ c.rbd }}<span v-if="i < JSON.parse(editevent.colegios_json).length - 1">, </span></span>
                            </template>
                            <template v-else>{{ editevent.rbd_colegio }}</template>
                        </p>
                    </div>
                    <div class="col-6">
                        <p class="mb-1 font-size-11 text-uppercase text-muted font-weight-bold">Colegio</p>
                        <p class="mb-3 font-size-13" style="color:#252C5F;">
                            <i class="mdi mdi-school mr-1" style="color:#61B7E4;"></i>
                            <template v-if="editevent.colegios_json && JSON.parse(editevent.colegios_json).length > 1">
                                <span v-for="(c,i) in JSON.parse(editevent.colegios_json)" :key="c.rbd">{{ c.nombre }}<span v-if="i < JSON.parse(editevent.colegios_json).length - 1">, </span></span>
                            </template>
                            <template v-else>{{ editevent.colegio }}</template>
                        </p>
                    </div>
                    <div class="col-6">
                        <p class="mb-1 font-size-11 text-uppercase text-muted font-weight-bold">Propietario Colegio</p>
                        <p class="mb-3 font-size-13" style="color:#252C5F;">
                            <i class="mdi mdi-account mr-1" style="color:#61B7E4;"></i>{{ editevent.propietario_colegio || '—' }}
                        </p>
                    </div>
                    <div class="col-6">
                        <p class="mb-1 font-size-11 text-uppercase text-muted font-weight-bold">Coordinador</p>
                        <p class="mb-3 font-size-13" style="color:#252C5F;">
                            <i class="mdi mdi-account-tie mr-1" style="color:#61B7E4;"></i>{{ editevent.coordinador_evento || '—' }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Footer -->
            <div class="d-flex justify-content-end px-4 pb-3" style="gap:8px;">
                <button class="btn btn-ugm-white" @click="closeModal">
                    <i class="mdi mdi-close mr-1"></i>Cerrar
                </button>
                <button class="btn btn-ugm-dark" @click="ver_evento(editevent)">
                    <i class="mdi mdi-arrow-right mr-1"></i>Ir al Evento
                </button>
            </div>
        </b-modal>
    </div>
</template>

<style scoped>
/* Tooltip fade */
.fade-tooltip-enter-active, .fade-tooltip-leave-active { transition: opacity .15s, transform .15s; }
.fade-tooltip-enter, .fade-tooltip-leave-to { opacity: 0; transform: translateY(-4px); }
@keyframes ugmTooltipIn {
  from { opacity:0; transform:translateY(-4px); }
  to   { opacity:1; transform:translateY(0); }
}
/* ── FullCalendar UGM ── */
.ugm-calendar :deep(.fc-toolbar-title) {
    font-size: 1rem;
    font-weight: 700;
    color: #252C5F;
    text-transform: capitalize;
}
.ugm-calendar :deep(.fc-button-primary) {
    background-color: #252C5F !important;
    border-color: #252C5F !important;
    font-size: 12px;
    font-weight: 600;
    border-radius: 5px !important;
}
.ugm-calendar :deep(.fc-button-primary:not(:disabled):hover) {
    background-color: #1a1f44 !important;
    border-color: #1a1f44 !important;
}
.ugm-calendar :deep(.fc-button-primary.fc-button-active) {
    background-color: #CB9700 !important;
    border-color: #CB9700 !important;
}
.ugm-calendar :deep(.fc-list-day-cushion) {
    background: linear-gradient(90deg, #252C5F 0%, #61B7E4 100%) !important;
    color: #fff !important;
    padding: 6px 14px !important;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .04em;
    text-transform: uppercase;
}
.ugm-calendar :deep(.fc-list-day-text),
.ugm-calendar :deep(.fc-list-day-side-text) {
    color: #fff !important;
}
.ugm-calendar :deep(.fc-list-event:hover td) {
    background: #f0f4fb !important;
    cursor: pointer;
}
.ugm-calendar :deep(.fc-list-event-title a) {
    color: #252C5F;
    font-weight: 600;
    font-size: 13px;
}
.ugm-calendar :deep(.fc-list-event-dot) {
    border-color: #CB9700 !important;
}
.ugm-calendar :deep(.fc-daygrid-event) {
    border-radius: 4px !important;
    font-size: 11px;
    font-weight: 600;
    padding: 1px 5px;
}
.ugm-calendar :deep(.fc-col-header-cell) {
    background: #252C5F;
    color: #fff;
    font-size: 12px;
    padding: 6px 0;
}
.ugm-calendar :deep(.fc-col-header-cell a) {
    color: #fff !important;
}
.ugm-calendar :deep(.fc-list-empty) {
    background: #f8f9fa;
    color: #6c757d;
    font-size: 13px;
}
/* ── Botones UGM ── */
.btn-ugm-dark {
    background-color: #252C5F;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 7px 16px;
    font-size: 13px;
    font-weight: 600;
    transition: background 0.2s;
}
.btn-ugm-dark:hover {
    background-color: #1a1f44;
    color: #fff;
}
.btn-ugm-white {
    background-color: #fff;
    color: #252C5F;
    border: 1.5px solid #252C5F;
    border-radius: 6px;
    padding: 7px 16px;
    font-size: 13px;
    font-weight: 600;
    transition: background 0.2s;
}
.btn-ugm-white:hover {
    background-color: #f0f2fa;
    color: #252C5F;
}
.btn-close-ugm {
    background: rgba(255,255,255,0.15);
    border: none;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    transition: background 0.2s;
    padding: 0;
}
.btn-close-ugm:hover {
    background: rgba(255,255,255,0.3);
}
</style>
